import { SafeJSON } from './../../shared/safe-json';

export class Parent {
    private json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
    }

    getPartyName(): string {
        return SafeJSON.get('partyName', this.json);
    }

    getRelationship(): string {
        return SafeJSON.get('relationship', this.json);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/parent.ts